import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

import "./image-tile.sass"

export const ImageTile = ({ image, alt = "" }) => {
  return (
    <div className={"_fp-image-tile"}>
      <GatsbyImage image={image} alt={alt} />
    </div>
  )
}
